import React from 'react';
import Box from '@mui/material/Box';

/**
 * PageContent — the scrollable/fill content region inside PageShell.
 *
 * Two modes:
 *
 * fill  (prop: `fill`)
 *   Used for list / DataGrid pages. Becomes a flex child that expands to
 *   fill remaining vertical space. The DataGrid inside is height: 100% and
 *   scrolls internally. No overflow on the page body.
 *
 * default (no `fill`)
 *   Used for forms and detail pages. Naturally sized — the page scrolls as
 *   one unit. Critical for mobile keyboards: never fix the height of a form
 *   region or the keyboard will cause nested-scroll chaos.
 *
 * Usage (grid screen):
 *   <PageContent fill>
 *     <ResponsiveDataGrid ... />
 *   </PageContent>
 *
 * Usage (form screen):
 *   <PageContent>
 *     <Form ...> ... </Form>
 *   </PageContent>
 */
export default function PageContent({ fill, children, sx, ...rest }) {
  return (
    <Box
      sx={{
        ...(fill
          ? {
              flex: '1 1 auto',
              minHeight: 0,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
            }
          : {
              flex: '1 1 auto',
              overflowY: 'auto',
              scrollbarGutter: 'stable',
            }),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
